import { NAME } from './constants';
import { router } from './router';

export const NahradniSazbaPujcovna = {
	name: NAME,
	router,
};
